<div class="form-group">
  <label for="prod-m">{{ 'form.discountType'| translate }}</label>
  <angular2-multiselect [data]="typeList"
      [(ngModel)]="typeSelected"
      [settings]="multiselectSettings_base"
      (onSelect)="onTypeSelect()">
  </angular2-multiselect>
</div>